import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

export const useUtilityObjects = () => {
  // fallback/err
  const errorObjectGLTF = useLoader(
    GLTFLoader,
    "/assets/models/utility/henge/fallback/error/error.glb",
  );

  // loader/in-process
  const loaderInProcessObjectGLTF = useLoader(
    GLTFLoader,
    "/assets/models/utility/henge/loader/in-process/loading.glb",
  );

  // loader/in-process/empty-file
  const loaderEmptyFileObjectGLTF = useLoader(
    GLTFLoader,
    "/assets/models/utility/henge/loader/in-process/empty-file.glb",
  );

  //================================================================

  return {
    errorObjectGLTF,
    loaderInProcessObjectGLTF,
    loaderEmptyFileObjectGLTF,
  };
};
